import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import _ from 'lodash';

import Link from './Link';
import { middleEllipsis } from '../../utilities/StringUtilities';
import { useEncodedFilterState } from '../../stores/FilterStateStore';
import { getUrlParamFromEncodedState } from '../../utilities/FilterStateUrlUtilities';

// Clear Fix warning: Plurals for locale undefined aren't loaded. Use i18n.loadLocaleData method to load plurals for specific locale. Using other plural rule as a fallback;
const viewDetails = (entity) => t`View Details for ${entity}`;

// General page
const capitalize = (s) => {
    if (!s || typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
};

export const usePageLink = (target, targetName, filters = [], excludedFilters = []) => {
    const [encodedFilterState] = useEncodedFilterState();
    const encoded = { ...encodedFilterState };
    filters.forEach((filter) => {
        encoded[capitalize(filter.name)] = filter.uuid;
    });
    const url = `${target}?${getUrlParamFromEncodedState(_.omit(encoded, excludedFilters))}`;
    return <Link to={url}>{targetName}</Link>;
};

export const PageLink = ({ target, targetName, filters, excludedFilters }) => {
    return usePageLink(target, targetName, filters, excludedFilters);
};

export const pageLinkFn = (target, targetName, filters, excludedFilters = []) => (
    <PageLink target={target} targetName={targetName} filters={filters} excludedFilters={excludedFilters} />
);

// Site detail page

export const useSiteDetailLinkFn = (entity) => {
    const [encodedFilterState] = useEncodedFilterState();

    if (entity === undefined) return null;

    const encoded = { ...encodedFilterState };
    encoded.Site = entity.uuid;
    return <Link to={`/site-detail?${getUrlParamFromEncodedState(encoded)}`}>{entity.name}</Link>;
};

export const SiteDetailLink = ({ site }) => {
    return useSiteDetailLinkFn(site);
};

export const siteDetailLinkFn = (site) => <SiteDetailLink site={site} />;

// Business service page

export const useBusinessServiceDetailLinkFn = (entity) => {
    const [encodedFilterState] = useEncodedFilterState();

    if (entity === undefined) return null;

    const encoded = { ...encodedFilterState };
    encoded.BusinessService = entity.uuid;
    return <Link to={`/business-service-detail?${getUrlParamFromEncodedState(encoded)}`}>{entity.name}</Link>;
};

export const BusinessServiceDetailLink = ({ businessService }) => {
    return useBusinessServiceDetailLinkFn(businessService);
};

export const businessServiceDetailLinkFn = (bs) => <BusinessServiceDetailLink businessService={bs} />;

// npoint-detail page

export const NPointDetailLink = ({ nPoint }) => {
    return useNPointDetailLinkFn(nPoint);
};

export const nPointDetailLinkFn = (nPoint) => <NPointDetailLink nPoint={nPoint} />;

export const useNPointDetailLinkFn = (entity) => {
    const [encodedFilterState] = useEncodedFilterState();

    if (entity === undefined) return null;

    const encoded = { ...encodedFilterState };
    encoded.Agent = entity.uuid;
    return (
        <Link to={`/agent-detail?${getUrlParamFromEncodedState(encoded)}`} title={i18n._(viewDetails(entity.name))}>
            {middleEllipsis(entity.name, 50)}
        </Link>
    );
};

// test-detail page

export const useTestDetailLinkFn = (test) => {
    const [encodedFilterState] = useEncodedFilterState();

    if (test === undefined) return null;

    const encoded = { ...encodedFilterState };
    encoded.Test = test.uuid;
    return (
        <Link to={`/test-detail?${getUrlParamFromEncodedState(encoded)}`} title={i18n._(viewDetails(test.name))}>
            {middleEllipsis(test.name, 50)}
        </Link>
    );
};

export const TestDetailLink = ({ test }) => {
    return useTestDetailLinkFn(test);
};

export const testDetailLinkFn = (test) => <TestDetailLink test={test} />;
